import { render, staticRenderFns } from "./Notifs.vue?vue&type=template&id=38b91b27&scoped=true&"
import script from "./Notifs.vue?vue&type=script&lang=js&"
export * from "./Notifs.vue?vue&type=script&lang=js&"
import style0 from "./Notifs.vue?vue&type=style&index=0&id=38b91b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b91b27",
  null
  
)

component.options.__file = "Notifs.vue"
export default component.exports